import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Box from "@mui/material/Box";
import {DefaultSettingTax} from "./DefaultSettingsTax";
import {DefaultSettingsSalesTax} from "./DefaultSettingsSalesTax";
import {DefaultSettingsRebatesTax} from "./DefaultSettingsRebatesTax";

const MONTHLY_USE_TAX_STATES = ['ALL', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'ID', 'IN', 'KS', 'KY', 'LA', 'MA', 'MI', 'MS', 'MT', 'NE', 'NV', 'NH', 'NM', 'NC', 'ND', 'OK', 'PA', 'RI', 'TN', 'UT', 'WA', 'WV', 'WI', 'WY', 'DC']
const UPFRONT_TAX_STATES = ['GA', 'IL', 'IA', 'ME', 'MD', 'MN', 'NJ', 'NY', 'OH', 'OR', 'SC', 'SD', 'TX', 'VT', 'VA']
const EXCLUDED_STATES = ['AK', 'HI', 'MO']


export const DefaultSettingsTaxes = ({fees, usState, setUsState}) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const isLoading = false

    const taxesForState = fees.filter(f => (f.state === usState) && f.is_taxed)
    const isMonthlyUseTaxState = MONTHLY_USE_TAX_STATES.includes(usState)
    const isUpfrontTaxState = UPFRONT_TAX_STATES.includes(usState)

    const isAllState = Boolean(usState === 'ALL')

    return (
        <Box>
            <div className={'ds-section-title'}>
                Taxes
            </div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            className={'header-cell'}
                            align="left"
                            width={isTabletOrMobile ? '60%' : '40%'}
                        >
                            Name
                        </TableCell>
                        {
                            /* Empty header cells keep the Taxes table on the same
                               column grid as Fees (40/20/20/20) so the Capped
                               boolean lines up — the "Capped" label is dropped. */
                            !isTabletOrMobile &&
                            <React.Fragment>
                                <TableCell className={'header-cell'} align="right" width={'20%'}/>
                                <TableCell className={'header-cell'} align="right" width={'20%'}/>
                                <TableCell className={'header-cell'} align="right" width={'20%'}/>
                            </React.Fragment>
                        }
                        {
                            isTabletOrMobile &&
                            <TableCell className={'header-cell'} align="right" width={'40%'}/>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        isUpfrontTaxState &&
                        <DefaultSettingsSalesTax/>
                    }
                    {
                        usState === 'NJ' &&
                        <DefaultSettingsSalesTax label={'Supplemental Title Fee'} field={'is_supplemental_title_fee_capped'}/>
                    }
                    {
                        isAllState &&
                        <DefaultSettingsRebatesTax/>
                    }
                    {
                        isMonthlyUseTaxState && taxesForState.map((fee, idx) => {
                            return (
                                <DefaultSettingTax
                                    key={fee.id}
                                    fee={fee}
                                    isLoading={isLoading}
                                />
                            )
                        })
                    }
                </TableBody>
            </Table>
        </Box>
    )
}